import mitt from 'mitt';
export const bus = mitt();
export const RUN_GUIDE = 'RUN_GUIDE';
export const GUIDE_REGISTER = 'GUIDE_REGISTER';
export const GUIDE_UNREGISTER = 'GUIDE_UNREGISTER';